// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"styles_Breadcrumb__KhDKm","item":"styles_item__I0Hb9","separator":"styles_separator__fVP0Y"};